module.exports = __webpack_public_path__ + "img/kefu.bc8fcf42.png";